import { Button } from '@payaca/ambrosia';
import { FC, type JSX } from 'react';

import { useReportUnsavedChanges } from './SettingsUnsavedChanges';

type Props = {
  isDirty: boolean;
  isSaving: boolean;
  /** Blocks saving while a field fails validation, since the save would no-op. */
  isValid: boolean;
  onSave: () => void;
  /**
   * Visible button text when a section stacks several sub-forms, so the
   * actions are distinguishable on screen, by voice control, and by
   * role/name locators alike.
   */
  label?: string;
};

/**
 * Save action for a settings sub-form. Saving is manual, so this also reports
 * unsaved changes to the section's navigation guard.
 */
const SettingsSaveButton: FC<Props> = ({
  isDirty,
  isSaving,
  isValid,
  onSave,
  label,
}: Props): JSX.Element => {
  useReportUnsavedChanges(isDirty && !isSaving);

  return (
    <div className="flex justify-end">
      <Button
        onClick={onSave}
        disabled={!isDirty || isSaving || !isValid}
        isProcessing={isSaving}
      >
        {label ?? 'Save'}
      </Button>
    </div>
  );
};

export default SettingsSaveButton;
